(function () {
  'use strict';

  document.querySelectorAll('.mtrx-nl__form').forEach(function (form) {
    // If Shopify already rendered a success/error state (non-JS fallback), do nothing
    if (form.querySelector('.mtrx-nl__message--success.is-visible')) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('.mtrx-nl__input');
      var submitBtn  = form.querySelector('.mtrx-nl__submit');
      var inputWrap  = form.querySelector('.mtrx-nl__input-wrap');
      var errorMsg   = form.querySelector('.mtrx-nl__message--error');
      var successTpl = form.querySelector('.mtrx-nl__success-text');

      if (!emailInput || !emailInput.value.trim()) {
        emailInput && emailInput.focus();
        return;
      }

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
      if (errorMsg) { errorMsg.style.display = 'none'; }

      var body = new URLSearchParams(new FormData(form));

      fetch(form.action, {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
        .then(function (res) {
          return res.text().then(function (html) {
            return { url: res.url, html: html };
          });
        })
        .then(function (data) {
          if (data.url.indexOf('posted_successfully') !== -1) {
            onSuccess(form, inputWrap, submitBtn, successTpl);
          } else {
            var doc    = new DOMParser().parseFromString(data.html, 'text/html');
            var errEl  = doc.querySelector('.mtrx-nl__message--error');
            var errTxt = errEl ? errEl.textContent.trim() : 'Revisa el email e inténtalo de nuevo.';
            onError(submitBtn, errorMsg, emailInput, errTxt);
          }
        })
        .catch(function () {
          onError(submitBtn, errorMsg, emailInput, 'Error de conexión. Inténtalo de nuevo.');
        });
    });
  });

  function onSuccess(form, inputWrap, submitBtn, successTpl) {
    form.classList.add('mtrx-nl__form--submitted');

    setTimeout(function () {
      if (inputWrap) inputWrap.style.display = 'none';
      if (submitBtn) submitBtn.style.display  = 'none';
      form.classList.remove('mtrx-nl__form--submitted');

      // Draw animated checkmark
      var check = document.createElement('div');
      check.className = 'mtrx-nl__check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML =
        '<svg class="mtrx-nl__check-svg" viewBox="0 0 52 52">' +
          '<circle class="mtrx-nl__check-circle" cx="26" cy="26" r="25" fill="none"/>' +
          '<path class="mtrx-nl__check-mark" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>' +
        '</svg>';
      form.insertBefore(check, form.firstChild);

      // Show success message
      var successText = successTpl ? successTpl.textContent.trim() : '¡Suscrito!';
      var msg = document.createElement('p');
      msg.className = 'mtrx-nl__message mtrx-nl__message--success mtrx-nl__message--animate';
      msg.textContent = successText;
      form.appendChild(msg);
    }, 320);
  }

  function onError(submitBtn, errorMsg, emailInput, message) {
    submitBtn.classList.remove('is-loading');
    submitBtn.disabled = false;

    if (errorMsg) {
      errorMsg.textContent = message;
      errorMsg.style.display = 'block';
    }

    emailInput.style.borderColor = 'rgba(233,81,75,0.6)';
    emailInput.focus();
    setTimeout(function () { emailInput.style.borderColor = ''; }, 3000);
  }
})();
